import { Theme } from '@mui/material';

export const dialogOverride = {
  paper: ({ theme }: { theme: Theme }) => ({
    padding: theme.spacing(2.5),
    borderRadius: 8,
    boxShadow: 'none',
    width: 'max-content',
    margin: theme.spacing(0.5)
  }),
};

export const dialogTitleOverride = {
  root: ({ theme }: { theme: Theme }) => ({
    padding: 0,
    paddingBottom: theme.spacing(2),
    fontWeight: 700,
    fontSize: 24,
  }),
};

export const dialogContentOverride = {
  root: {
    padding: 0,
  },
};

export const dialogActionsOverride = {
  root: ({ theme }: { theme: Theme }) => ({
    padding: 0,
    paddingTop: theme.spacing(4.5),
    justifyContent: 'space-between',

    ['& > *']: {
      flex: 1,
    },
  }),
};
